import type { NextRouter } from 'next/router';

type RouterSlugSource = Pick<NextRouter, 'asPath' | 'query'>;

const matchesSegment = (segment: string | undefined, value: string): boolean =>
  segment?.toLowerCase() === value.toLowerCase();

// On a custom domain the browser URL omits the /<org> segment (the middleware re-prepends it
// server-side) and Next's i18n strips a configured-locale prefix, so asPath-derived segments
// shift left and consumers like TranslationMenu read the wrong indexes. Rebuild the canonical
// /<org>/<locale>/... segment list from the route params, which the middleware rewrite resolved
// correctly on every host.
export const buildCanonicalSlug = (router: RouterSlugSource): string[] => {
  const segments = router.asPath.split('?')[0].split('/').slice(1);
  const { organization, locale } = router.query;
  if (typeof organization !== 'string' || organization.length === 0) {
    return segments;
  }
  if (!matchesSegment(segments[0], organization)) {
    segments.unshift(organization);
  }
  if (typeof locale === 'string' && locale.length > 0 && !matchesSegment(segments[1], locale)) {
    segments.splice(1, 0, locale);
  }
  return segments;
};
